export const environment = {
    production: false,
    API_ENDPOINT: 'http://localhost:8000/',
    lemu_base: 'http://localhost:8000/',
    WS_URL: 'wss://luq81qnp8d.execute-api.us-east-2.amazonaws.com/dev'
}